import axios from "axios";

export const autoCompleteZipCode = search => {
  console.log({ search });
  return axios
    .get(`https://vicopo.selfbuild.fr/cherche/${search}`, {})
    .then(({ data }) => {
      console.log({ data });
      if (!data.cities) return [];
      return data.cities;
    })
    .catch(function(error) {
      console.log(error);
      return [];
    })
    .finally(function() {});
};

export default autoCompleteZipCode;
